var _defs, _path, _path2, _g, _g2, _g3, _text, _path3, _path4, _g4, _g5, _g6, _path5, _g7, _g8, _g9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDatapilotSlider1 = function SvgDatapilotSlider1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 937 484"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "datapilot_slider1_svg__b",
    width: 937,
    height: 266,
    x: 0,
    y: 218,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.11
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "datapilot_slider1_svg__c",
    width: 227,
    height: 96,
    x: 0,
    y: 120,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.11
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-2",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "datapilot_slider1_svg__d",
    width: 227,
    height: 21,
    x: 0,
    y: 195,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-3",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.11
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-3",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "datapilot_slider1_svg__l",
    width: 227,
    height: 96,
    x: 236.666,
    y: 120,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-4",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.11
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-4",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "datapilot_slider1_svg__m",
    width: 227,
    height: 21,
    x: 236.666,
    y: 195,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-5",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.11
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-5",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "datapilot_slider1_svg__n",
    width: 227,
    height: 96,
    x: 473.333,
    y: 120,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-6",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.11
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-6",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "datapilot_slider1_svg__o",
    width: 227,
    height: 21,
    x: 473.333,
    y: 195,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-7",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.11
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-7",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "datapilot_slider1_svg__p",
    width: 227,
    height: 96,
    x: 710,
    y: 120,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-8",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.11
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-8",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "datapilot_slider1_svg__q",
    width: 227,
    height: 21,
    x: 710,
    y: 195,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-9",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.11
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-9",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "datapilot_slider1_svg__a",
    x1: 0.039,
    x2: 1.039,
    y1: 0.502,
    y2: 0.502,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff603c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e8a50f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#datapilot_slider1_svg__a",
    id: "datapilot_slider1_svg__e",
    x1: 0,
    x2: 1,
    y1: 0.5,
    y2: 0.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#datapilot_slider1_svg__a",
    id: "datapilot_slider1_svg__f",
    x1: 0.012,
    x2: 1.01,
    y1: 0.394,
    y2: 0.394
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#datapilot_slider1_svg__a",
    id: "datapilot_slider1_svg__g",
    x1: -4.606,
    x2: -3.447,
    y1: 1.434,
    y2: 1.434
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#datapilot_slider1_svg__a",
    id: "datapilot_slider1_svg__h",
    x1: -0.722,
    x2: 0.304,
    y1: 0.901,
    y2: 0.901
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#datapilot_slider1_svg__a",
    id: "datapilot_slider1_svg__i",
    x1: -1.321,
    x2: -0.252,
    y1: 0.802,
    y2: 0.802
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#datapilot_slider1_svg__a",
    id: "datapilot_slider1_svg__j",
    x1: -0.309,
    x2: 0.725,
    y1: 0.637,
    y2: 0.637
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#datapilot_slider1_svg__a",
    id: "datapilot_slider1_svg__k",
    x1: -1.682,
    x2: -0.682,
    y1: 1.243,
    y2: 1.243
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fcfcfc",
    d: "M9 0h919v480H9z",
    "data-name": "Rectangle 33693"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcfcfc",
    d: "M9 64h919v416H9z",
    "data-name": "Rectangle 133"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11",
    transform: "translate(9 227)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#datapilot_slider1_svg__b)",
    transform: "translate(-9 -227)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 919,
    height: 248,
    fill: "#fff",
    "data-name": "Rectangle 138",
    rx: 10,
    transform: "translate(9 227)"
  })), /*#__PURE__*/React.createElement("text", {
    "data-name": "Recent Projects",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 20,
    fontWeight: 500,
    transform: "translate(11 34)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Recent Projects")), /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 3,
    fill: "#f05a5c",
    "data-name": "Rectangle 140",
    rx: 1.5,
    transform: "translate(12 44)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 395"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#272727",
    "data-name": "Group 10",
    fontFamily: "Poppins-SemiBold, Poppins",
    fontSize: 16,
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(12 88)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Project")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(201.001 88)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Platform")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(325.001 88)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Responses")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(444 88)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Completes")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(612 88)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -38.4,
    y: 0
  }, "Date")), /*#__PURE__*/React.createElement("text", {
    "data-name": "Screen Out",
    transform: "translate(787.001 88)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -89.312,
    y: 0
  }, "Screen Out")), /*#__PURE__*/React.createElement("text", {
    "data-name": "Sample Size",
    transform: "translate(909 88)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -98.128,
    y: 0
  }, "Sample Size"))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 107h899v60H8z",
    "data-name": "Rectangle 11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e5e5e5",
    d: "M8 166h899v1H8z"
  }), /*#__PURE__*/React.createElement("text", {
    "data-name": "3452_user-survey",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(8 143.185)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "3452_user-survey")), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(201.495 143.185)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Confirmit")), /*#__PURE__*/React.createElement("text", {
    "data-name": 25,
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(335.495 143.185)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.624,
    y: 0
  }, "25")), /*#__PURE__*/React.createElement("text", {
    "data-name": 19,
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(451.495 143.185)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -7.6,
    y: 0
  }, "19")), /*#__PURE__*/React.createElement("text", {
    "data-name": "24/07/2024",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(574.495 143.185)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "24/07/2024 ")), /*#__PURE__*/React.createElement("text", {
    "data-name": 6,
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(697.495 143.185)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "06")), /*#__PURE__*/React.createElement("text", {
    "data-name": 40,
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(812.495 143.185)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "40"))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58458"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fcfcfc",
    d: "M8 167h899v60H8z",
    "data-name": "Rectangle 11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e5e5e5",
    d: "M8 226h899v1H8z",
    "data-name": "line"
  }), /*#__PURE__*/React.createElement("text", {
    "data-name": "2864_user-survey",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(8 203.185)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2864_user-survey")), /*#__PURE__*/React.createElement("text", {
    "data-name": "Confirmit",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(201.495 203.185)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Confirmit")), /*#__PURE__*/React.createElement("text", {
    "data-name": 20,
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(335.495 203.185)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.624,
    y: 0
  }, "20")), /*#__PURE__*/React.createElement("text", {
    "data-name": 15,
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(451.495 203.185)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -7.584,
    y: 0
  }, "15")), /*#__PURE__*/React.createElement("text", {
    "data-name": "25/07/2024",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(574.495 203.185)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "25/07/2024 ")), /*#__PURE__*/React.createElement("text", {
    "data-name": 4,
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(697.495 203.185)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "04")), /*#__PURE__*/React.createElement("text", {
    "data-name": 65,
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(812.495 203.185)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "65")))), /*#__PURE__*/React.createElement("text", {
    fill: "#f05a5c",
    "data-name": "View All",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 15,
    fontWeight: 500,
    transform: "translate(851 29)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "View All")))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 396",
    transform: "translate(8 74)"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 24,
    fontWeight: 500,
    transform: "translate(0 25)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Dashboard")), /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 3,
    fill: "#f05a5c",
    "data-name": "Rectangle 141",
    rx: 1.5,
    transform: "translate(1 35)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1955"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#datapilot_slider1_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 129h203a3 3 0 0 1 3 3v75H9v-75a3 3 0 0 1 3-3",
    "data-name": "Rectangle 18"
  })), /*#__PURE__*/React.createElement("text", {
    "data-name": "Total Projects",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 12,
    transform: "translate(19 150)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Total Projects")), /*#__PURE__*/React.createElement("text", {
    fill: "#313131",
    "data-name": 46,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontSize: 26,
    fontWeight: 600,
    transform: "translate(19 184)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "46")), /*#__PURE__*/React.createElement("g", {
    filter: "url(#datapilot_slider1_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#568bb9",
    d: "M9 204h209a3 3 0 0 1-3 3H12a3 3 0 0 1-3-3",
    "data-name": "Rectangle 135"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#568bb9",
    fillRule: "evenodd",
    d: "M164.54 188.028h-18.136a1.39 1.39 0 0 1-1.387-1.384v-38.129h9.627a.98.98 0 0 0 .982-.982v-7.593h26.678a1.39 1.39 0 0 1 1.381 1.388v22.381a15.782 15.782 0 0 0-19.145 24.319m32.237-14.112a3.88 3.88 0 0 0-3.756 2.95h-16.479a.916.916 0 0 1-.287-1.787 2.719 2.719 0 1 0 2.847 3.62h2.033a4.684 4.684 0 1 1-1.282-4.225 4.5 4.5 0 0 1 .48.562h3.371a7.674 7.674 0 1 0 .454 3.667h1.975a9.615 9.615 0 1 1-.355-3.667h4.442a13.958 13.958 0 1 0 .241 3.667h2.563a3.88 3.88 0 0 0 3.756 2.951h13.19l-3.212-4.06 3.209-3.666Zm-19.986-20.98h-24.88a.983.983 0 0 0 0 1.965h24.88a.983.983 0 0 0 0-1.965m0 6.387h-24.88a.983.983 0 0 0 0 1.965h24.88a.983.983 0 0 0 0-1.965m-15.495 6.389h-9.385a.982.982 0 1 0 0 1.964h9.385a.982.982 0 0 0 0-1.964m-3.092 6.388h-6.293a.983.983 0 0 0 0 1.965h6.293a.983.983 0 0 0 0-1.965m0 6.387h-6.293a.983.983 0 0 0 0 1.965h6.293a.983.983 0 0 0 0-1.965m-11.969-31.937h7.424v-5.838Z",
    "data-name": "Path 2197"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    fill: "#656565",
    "data-name": "Dashboard",
    fontFamily: "Poppins-Light, Poppins",
    fontSize: 15,
    fontWeight: 300,
    transform: "translate(845 98)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Dashboard"))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcfcfc",
    d: "M9 0h919v64H9z",
    "data-name": "Rectangle 4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#e8e8e8",
    d: "M9 64h919",
    "data-name": "Line 1"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 373"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Component 4 \\u2013 10",
    transform: "translate(306 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 165,
    height: 40,
    fill: "#f2f2f2",
    "data-name": "Rectangle 10",
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1934"
  }, /*#__PURE__*/React.createElement("text", {
    "data-name": "Dashboard",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(60 26)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Dashboard")), /*#__PURE__*/React.createElement("path", {
    d: "M15 21.111h8.889V10H15ZM15 30h8.889v-6.667H15Zm11.111 0H35V18.889h-8.889Zm0-20v6.667H35V10Z",
    "data-name": "Icon material-dashboard"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#f15b5b",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M150 41H16",
    "data-name": "Line 6"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Component 4 \\u2013 11",
    transform: "translate(489 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 165,
    height: 40,
    fill: "#f9f9f9",
    "data-name": "Rectangle 10",
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1920"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(74.125 26)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Projects")), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M49 27.778A2.21 2.21 0 0 1 46.8 30H29.2a2.21 2.21 0 0 1-2.2-2.222V12.222A2.21 2.21 0 0 1 29.2 10h5.5l2.2 3.333h9.9a2.21 2.21 0 0 1 2.2 2.223Z",
    "data-name": "Icon feather-folder"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Component 4 \\u2013 12",
    transform: "translate(667 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 165,
    height: 40,
    fill: "#f9f9f9",
    "data-name": "Rectangle 10",
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1921"
  }, /*#__PURE__*/React.createElement("text", {
    "data-name": "Add Project",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(59.724 26)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Add Project")), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    "data-name": "Icon feather-folder-plus"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.134 27.778A2.22 2.22 0 0 1 34.921 30H17.213A2.22 2.22 0 0 1 15 27.778V12.222A2.22 2.22 0 0 1 17.213 10h5.534l2.213 3.333h9.96a2.22 2.22 0 0 1 2.213 2.222Z",
    "data-name": "Path 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.067 18.889v6.667",
    "data-name": "Path 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.747 22.222h6.64",
    "data-name": "Path 7"
  })))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Component 2 \\u2013 4"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2",
    transform: "translate(880 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 40,
    fill: "#e0e0e0",
    "data-name": "Rectangle 3",
    rx: 5
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 20,
    fontWeight: 500,
    transform: "translate(24 28)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -14.7,
    y: 0
  }, "AG"))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2661"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2658"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#datapilot_slider1_svg__a)",
    d: "M29.506 13.184A12.886 12.886 0 0 1 17.039 30.17 12.88 12.88 0 0 1 4.413 17.039a12.883 12.883 0 0 1 21-9.744 6.6 6.6 0 0 0 .854.567 20 20 0 0 1 1.351-1.606 17 17 0 0 1 1.461-1.577l-.064-.03.064.03.024-.011a17.293 17.293 0 1 0-18.86 28.422 17.3 17.3 0 0 0 23.1-22.215 23 23 0 0 0-.215-.512l-.03.01",
    "data-name": "Path 3839",
    transform: "rotate(-8 151.163 -678.478)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#datapilot_slider1_svg__e)",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25,
    d: "M13.52 25.452 0 11.131l11.769 6.494L36.127 0Z",
    "data-name": "Path 3840",
    transform: "rotate(-8 149.384 -702.884)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2659",
    transform: "rotate(-8 81.374 -883.545)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#datapilot_slider1_svg__f)",
    d: "M3.564.128a.567.567 0 1 1 .677.909L.9 3.535a.567.567 0 0 1-.678-.909Z",
    "data-name": "Path 3841",
    transform: "translate(1.017 10.371)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#datapilot_slider1_svg__g)",
    d: "M2.853.216a.567.567 0 1 1 .86.738L.994 4.122a.568.568 0 0 1-.86-.738Z",
    "data-name": "Path 3842",
    transform: "translate(2.958 12.462)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#datapilot_slider1_svg__h)",
    fillRule: "evenodd",
    d: "M3.669 3.636 0 2.932C3.706-.168 3.907-.026 6.612.013a18.6 18.6 0 0 0-2.943 3.625Z",
    "data-name": "Path 3843",
    transform: "translate(0 5.463)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#datapilot_slider1_svg__i)",
    fillRule: "evenodd",
    d: "m0 2.355.1 3.689C3.727 2.853 3.617 2.634 4.031 0A26.6 26.6 0 0 1 0 2.357Z",
    "data-name": "Path 3844",
    transform: "translate(8.406 12.269)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#datapilot_slider1_svg__j)",
    fillRule: "evenodd",
    d: "M13.826 6.566c-1.455 2.427-7.259 6.934-10.37 7.793L0 10.329c1.281-2.906 6.7-7.947 9.322-9.015 6.9-2.77 8.3-1.224 4.505 5.253ZM11.573 3.94a2.343 2.343 0 0 1-.3 3.319 2.34 2.34 0 0 1-3.326-.213 2.386 2.386 0 1 1 3.626-3.106",
    "data-name": "Path 3845",
    transform: "translate(3.702)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.372,
    cy: 1.372,
    r: 1.372,
    fill: "url(#datapilot_slider1_svg__k)",
    "data-name": "Ellipse 15",
    transform: "translate(12.092 4.122)"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.991 41.617q-1.126 0-1.126-1.192V20.261q0-1.192 1.126-1.192h5.5a7.31 7.31 0 0 1 6.242 2.738q2.059 2.738 2.059 8.5 0 5.8-2.059 8.552a7.29 7.29 0 0 1-6.242 2.754Zm3.153-3.608h2.378a3.13 3.13 0 0 0 3.008-1.82 13.9 13.9 0 0 0 .917-5.879 13.7 13.7 0 0 0-.917-5.83 3.13 3.13 0 0 0-3.008-1.8h-2.378Zm17.44 3.833a4.38 4.38 0 0 1-3.427-1.341 5.3 5.3 0 0 1-1.207-3.688 5.8 5.8 0 0 1 .8-3.044 5.47 5.47 0 0 1 2.606-2.126 12.1 12.1 0 0 1 4.794-.789v-.87a2.4 2.4 0 0 0-.5-1.594 2.14 2.14 0 0 0-1.721-.6 7.9 7.9 0 0 0-2.091.258 13 13 0 0 0-1.544.515 2.7 2.7 0 0 1-.869.258q-.29 0-.467-.419a4 4 0 0 1-.257-.966 6.4 6.4 0 0 1-.08-.9q0-.419.82-.886a8.4 8.4 0 0 1 2.108-.789 10.8 10.8 0 0 1 2.638-.322q3.185 0 4.633 1.466a5.24 5.24 0 0 1 1.448 3.849v6.474a19 19 0 0 0 .161 2.963 8.5 8.5 0 0 1 .161 1.321.58.58 0 0 1-.37.515 3.6 3.6 0 0 1-.885.306 9 9 0 0 1-1 .161q-.483.048-.708.048a.78.78 0 0 1-.756-.387 5.4 5.4 0 0 1-.4-1.385 5.5 5.5 0 0 1-1.48 1.337 4.34 4.34 0 0 1-2.407.636Zm1.287-3.028a2.35 2.35 0 0 0 1.3-.387 3.1 3.1 0 0 0 .981-1.031v-3.93a4.98 4.98 0 0 0-3.169.773 2.86 2.86 0 0 0-.917 2.319 2.7 2.7 0 0 0 .456 1.643 1.57 1.57 0 0 0 1.349.614Zm13.932 3.028a4.07 4.07 0 0 1-2.832-1.015 4.4 4.4 0 0 1-1.126-3.4v-9.406h-.9q-.869 0-.869-1.385v-.483q0-1.385.869-1.385h.9l.483-3.157q.161-.934 1.416-.934h.772q1.448 0 1.448.934v3.157h1.641q.869 0 .869 1.385v.483q0 1.385-.869 1.385h-1.641v8.987a2.6 2.6 0 0 0 .209 1.224.8.8 0 0 0 .756.354 2.4 2.4 0 0 0 .66-.064 1.5 1.5 0 0 1 .433-.062q.257 0 .418.4a4.3 4.3 0 0 1 .241.886 5 5 0 0 1 .08.741.87.87 0 0 1-.45.725 3.4 3.4 0 0 1-1.142.467 6 6 0 0 1-1.365.164Zm9.009 0a4.38 4.38 0 0 1-3.426-1.341 5.3 5.3 0 0 1-1.207-3.688 5.8 5.8 0 0 1 .8-3.044 5.47 5.47 0 0 1 2.606-2.126 12.1 12.1 0 0 1 4.794-.789v-.87a2.4 2.4 0 0 0-.5-1.594 2.14 2.14 0 0 0-1.721-.6 7.9 7.9 0 0 0-2.091.258 13 13 0 0 0-1.544.515 2.7 2.7 0 0 1-.869.258q-.29 0-.467-.419a4 4 0 0 1-.257-.966 6.4 6.4 0 0 1-.08-.9q0-.419.821-.886a8.4 8.4 0 0 1 2.108-.789 10.8 10.8 0 0 1 2.638-.322q3.185 0 4.633 1.466a5.24 5.24 0 0 1 1.448 3.849v6.474a19 19 0 0 0 .161 2.963 8.5 8.5 0 0 1 .161 1.321.58.58 0 0 1-.37.515 3.6 3.6 0 0 1-.885.306 9 9 0 0 1-1 .161q-.483.048-.708.048a.78.78 0 0 1-.756-.387 5.4 5.4 0 0 1-.4-1.385 5.5 5.5 0 0 1-1.48 1.337 4.34 4.34 0 0 1-2.408.636Zm1.287-3.028a2.35 2.35 0 0 0 1.3-.387 3.1 3.1 0 0 0 .981-1.031v-3.93a4.98 4.98 0 0 0-3.169.773 2.86 2.86 0 0 0-.917 2.319 2.7 2.7 0 0 0 .45 1.643 1.57 1.57 0 0 0 1.356.614Zm11.713 2.868a2.7 2.7 0 0 1-1.335-.242.77.77 0 0 1-.4-.693V20.261q0-1.192 1.126-1.192h5.277q6.661 0 6.661 6.861 0 6.893-6.661 6.893h-2.126v7.924a.77.77 0 0 1-.4.693 2.7 2.7 0 0 1-1.335.242Zm2.542-12.466h2.124a2.21 2.21 0 0 0 1.914-.773 4.35 4.35 0 0 0 .563-2.512 4.28 4.28 0 0 0-.563-2.48 2.21 2.21 0 0 0-1.914-.773h-2.124Zm12.131 12.466a2.64 2.64 0 0 1-1.3-.242.77.77 0 0 1-.4-.693V25.64a.77.77 0 0 1 .4-.693 2.64 2.64 0 0 1 1.3-.242h.708a2.64 2.64 0 0 1 1.3.242.77.77 0 0 1 .4.693v15.107a.77.77 0 0 1-.4.693 2.64 2.64 0 0 1-1.3.242Zm.386-18.781a3.8 3.8 0 0 1-1.577-.242.75.75 0 0 1-.483-.693v-2.319a.73.73 0 0 1 .483-.66 3.8 3.8 0 0 1 1.577-.242 3.9 3.9 0 0 1 1.544.225.72.72 0 0 1 .483.676v2.319a.75.75 0 0 1-.483.693 3.66 3.66 0 0 1-1.544.243m9.267 18.94a4.07 4.07 0 0 1-2.832-1.015 4.4 4.4 0 0 1-1.126-3.4V18.301a.77.77 0 0 1 .4-.693 2.64 2.64 0 0 1 1.3-.242h.708a2.64 2.64 0 0 1 1.3.242.77.77 0 0 1 .4.693v18.71a2.6 2.6 0 0 0 .209 1.224.8.8 0 0 0 .756.354 2.4 2.4 0 0 0 .66-.064 1.5 1.5 0 0 1 .434-.064q.257 0 .418.4a4.3 4.3 0 0 1 .241.886 5 5 0 0 1 .08.741.87.87 0 0 1-.45.725 3.4 3.4 0 0 1-1.142.467 6 6 0 0 1-1.356.163Zm48.522 0a4.07 4.07 0 0 1-2.832-1.015 4.4 4.4 0 0 1-1.126-3.4V28.02h-.9q-.869 0-.869-1.385v-.483q0-1.385.869-1.385h.9l.483-3.157q.161-.934 1.416-.934h.772q1.448 0 1.448.934v3.157h1.641q.869 0 .869 1.385v.483q0 1.385-.869 1.385h-1.64v8.987a2.6 2.6 0 0 0 .209 1.224.8.8 0 0 0 .756.354 2.4 2.4 0 0 0 .66-.064 1.5 1.5 0 0 1 .434-.064q.257 0 .418.4a4.3 4.3 0 0 1 .241.886 5 5 0 0 1 .08.741.87.87 0 0 1-.451.725 3.4 3.4 0 0 1-1.142.467 6 6 0 0 1-1.367.167Z",
    "data-name": "Path 3846"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58454"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#datapilot_slider1_svg__l)",
    transform: "translate(-.004)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M248.67 129h203a3 3 0 0 1 3 3v75h-209v-75a3 3 0 0 1 3-3",
    "data-name": "Rectangle 18"
  })), /*#__PURE__*/React.createElement("text", {
    "data-name": "Total Response",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 12,
    transform: "translate(255.666 150)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Total Response")), /*#__PURE__*/React.createElement("text", {
    fill: "#313131",
    "data-name": 6,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontSize: 26,
    fontWeight: 600,
    transform: "translate(255.666 184)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "06")), /*#__PURE__*/React.createElement("g", {
    filter: "url(#datapilot_slider1_svg__m)",
    transform: "translate(-.004)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e48055",
    d: "M245.67 204h209a3 3 0 0 1-3 3h-203a3 3 0 0 1-3-3",
    "data-name": "Rectangle 135"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#e48055",
    fillRule: "evenodd",
    d: "M407.027 173.688a.9.9 0 0 1 0-1.8h32.862a.9.9 0 0 1 0 1.8Zm0-6.318a.9.9 0 1 1 0-1.8h32.862a.9.9 0 1 1 0 1.8Zm16.432-6.323a.9.9 0 0 1 0-1.8h16.43a.9.9 0 0 1 0 1.8Zm-5-15.877a.86.86 0 0 1-.352-.286 13.6 13.6 0 0 0-4.845-2.387 14.8 14.8 0 0 0-6.644-.224.9.9 0 0 1-1.116-.871V137l-13.758 9.464 13.752 9.647v-4.386a.9.9 0 0 1 .773-.888 22.3 22.3 0 0 1 9.966.9 22 22 0 0 1 7.089 3.855 13.9 13.9 0 0 0-.833-4.655 13.7 13.7 0 0 0-3.567-5.352 11 11 0 0 0-.471-.414Zm-17.272 10.1v17.519a5.76 5.76 0 0 0 1.721 4.136 6 6 0 0 0 4.226 1.706h3.9a.9.9 0 0 1 .9.9v9.707l12.86-10.4a.9.9 0 0 1 .562-.2h14.532a6.6 6.6 0 0 0 4.688-2.011 6.84 6.84 0 0 0 2-4.781v-20.544a6.24 6.24 0 0 0-1.692-4.319 5.55 5.55 0 0 0-4.046-1.732h-19.731a15.4 15.4 0 0 1 3.07 5.074 15.8 15.8 0 0 1 .831 7.282.9.9 0 0 1-1.556.5 20.05 20.05 0 0 0-7.765-4.664 20.6 20.6 0 0 0-8.393-.921v5.308a.9.9 0 0 1-1.475.688Z",
    "data-name": "Path 2498"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58455"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#datapilot_slider1_svg__n)",
    transform: "translate(.003)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M485.33 129h203a3 3 0 0 1 3 3v75h-209v-75a3 3 0 0 1 3-3",
    "data-name": "Rectangle 18"
  })), /*#__PURE__*/React.createElement("text", {
    "data-name": "Total Completes",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 12,
    transform: "translate(492.333 150)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Total Completes")), /*#__PURE__*/React.createElement("text", {
    fill: "#313131",
    "data-name": 40,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontSize: 26,
    fontWeight: 600,
    transform: "translate(492.333 184)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "40")), /*#__PURE__*/React.createElement("g", {
    filter: "url(#datapilot_slider1_svg__o)",
    transform: "translate(.003)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#57b964",
    d: "M482.33 204h209a3 3 0 0 1-3 3h-203a3 3 0 0 1-3-3",
    "data-name": "Rectangle 135"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "25 certificate"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#57b964",
    d: "M681.36 170.289a5.983 5.983 0 0 0 0-8.258l-1.179-1.238a2.15 2.15 0 0 1-.533-1.992l.4-1.656a5.98 5.98 0 0 0-4.131-7.154l-1.635-.481a2.14 2.14 0 0 1-1.461-1.459l-.479-1.635a5.973 5.973 0 0 0-7.16-4.131l-1.656.4a2.14 2.14 0 0 1-1.993-.536l-1.237-1.177a5.983 5.983 0 0 0-8.258 0l-1.239 1.179a2.16 2.16 0 0 1-1.992.533l-1.645-.4a5.985 5.985 0 0 0-7.16 4.131l-.481 1.635a2.14 2.14 0 0 1-1.459 1.461l-1.635.479a5.98 5.98 0 0 0-4.131 7.16l.4 1.656a2.15 2.15 0 0 1-.535 1.994l-1.176 1.236a5.983 5.983 0 0 0 0 8.258l1.179 1.238a2.15 2.15 0 0 1 .533 1.988l-.4 1.656a5.98 5.98 0 0 0 4.131 7.149l1.635.481a2.14 2.14 0 0 1 1.461 1.459l.481 1.637a5.97 5.97 0 0 0 7.158 4.129l1.656-.4a2.15 2.15 0 0 1 1.994.535l1.236 1.177a5.985 5.985 0 0 0 8.258 0l1.238-1.179a2.14 2.14 0 0 1 1.992-.533l1.656.4a5.98 5.98 0 0 0 7.149-4.131l.481-1.635a2.14 2.14 0 0 1 1.459-1.461l1.637-.481a5.98 5.98 0 0 0 4.129-7.158l-.4-1.656a2.15 2.15 0 0 1 .535-1.989Zm-12.727-9.424-13.916 13.346a1.917 1.917 0 0 1-2.655 0l-8.35-8a1.917 1.917 0 0 1 2.655-2.766l7.024 6.744 12.585-12.081a1.917 1.917 0 0 1 2.657 2.757",
    "data-name": "Path 2172"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58456"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#datapilot_slider1_svg__p)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M722 129h203a3 3 0 0 1 3 3v75H719v-75a3 3 0 0 1 3-3",
    "data-name": "Rectangle 18"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#datapilot_slider1_svg__q)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M719 204h209a3 3 0 0 1-3 3H722a3 3 0 0 1-3-3",
    "data-name": "Rectangle 135"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58457"
  }, /*#__PURE__*/React.createElement("text", {
    "data-name": "Add Project",
    fontFamily: "Poppins-Light, Poppins",
    fontSize: 17,
    fontWeight: 300,
    transform: "translate(796.011 174)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Add Project")), /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M764.992 157.001a10.995 10.995 0 1 0 11 10.99 11.01 11.01 0 0 0-11-10.99m0 21.3a10.308 10.308 0 1 1 10.313-10.31 10.32 10.32 0 0 1-10.313 10.313Zm7.276-10.31a.344.344 0 0 1-.345.345h-6.581v6.584a.345.345 0 0 1-.689 0v-6.582h-6.582a.345.345 0 1 1 0-.689h6.584v-6.579a.345.345 0 1 1 .689 0v6.584h6.584a.34.34 0 0 1 .34.337",
    "data-name": "Path 2196"
  })))));
};
export default SvgDatapilotSlider1;